module.exports = __webpack_public_path__ + "img/y-128.a46d0e31.png";